'use client';

import { useState, useEffect, useRef } from 'react';

export const useOffsetTop = ({ gap = 0 }: { gap?: number }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [isReached, setIsReached] = useState(false);

  const [isPassed, setIsPassed] = useState(false);

  useEffect(() => {
    const handler = () => {
      if (ref.current) {
        const scrollY = window.scrollY;

        const offsetHeight = ref.current.offsetHeight;

        const offsetTop = ref.current.offsetTop;

        setIsReached(scrollY > offsetTop - gap);

        setIsPassed(scrollY > offsetTop + offsetHeight);
      }
    };

    window.addEventListener('scroll', handler);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [gap]);

  return { ref, isReached, isPassed };
};
